/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { ReactSVG } from 'react-svg';
import { LoadingIndicators } from '../../../../canvasComponents/index';
import { IntlProvider } from 'react-intl';
import { AudaTargetModal } from '../AudaTargetModal/AudaTargetModal';
import { AudaTargetScript } from './AudaTargetScript';
import { fetchAudaTargetImages } from '../../../../services/documentService';
import { useErrorStatus } from '../../../../components/FormioErrorHandler/FormioErrorPopup';
import { AUDATARGET_GET_VEHICLE_IMAGE_FAILED, AUDATARGET_VEHICLE_IMAGE_SYSTEM_FAILED } from '../../../../containers/Error/ErrorTypes';
import '../CustomAudaTarget.scss';

export function AudaTarget({ setAudaTargetValue, vehicleBody, localParams, intl }) {
  const { setError } = useErrorStatus();
  const [showModal, setShowModal] = useState(false);
  const [svgsLoaded, setSvgsLoaded] = useState(false);
  const [selectedPartModal, setSelectedPartModal] = useState('');
  const [dataImage, setDataImage] = useState(null);

  useEffect(() => {
    async function fetchSvgs(vehicle) {
      try {
        const fetchedSvgs = await fetchAudaTargetImages(vehicle);
        if (fetchedSvgs?.data.fetchAudaTargetImages?.base64Image) {
          setDataImage(fetchedSvgs.data?.fetchAudaTargetImages.base64Image);
        }

        if (fetchedSvgs?.errors) {
          fetchedSvgs.errors[0].type = AUDATARGET_GET_VEHICLE_IMAGE_FAILED;
          fetchedSvgs.errors[0].state = 'audatarget';
          setError(fetchedSvgs.errors[0]);
        }

        setSvgsLoaded(true);
      } catch (error) {
        setSvgsLoaded(true);
        setError({
          type: AUDATARGET_VEHICLE_IMAGE_SYSTEM_FAILED,
          state: 'audatarget',
        });
      }
    }
    if (vehicleBody) { fetchSvgs(vehicleBody); } else {
      setSvgsLoaded(true);
    }
  }, []);

  const injectScript = (err) => {
    if (svgsLoaded && err === null) {
      const svgElements = document.querySelector('.audatarget-container svg');
      if (svgElements) {
        AudaTargetScript(setShowModal, setSelectedPartModal, intl);
      }
    }
  };

  return (
    <IntlProvider locale={localParams?.lang} messages={localParams?.i18n}>
      {!svgsLoaded
        ? (
          <div className="cliploader-container">
            <LoadingIndicators.QuoteLoading loading={!svgsLoaded} />
          </div>
        ) : svgsLoaded && dataImage && (
          <div className="audatarget-container">
            <ReactSVG
              afterInjection={(err) => injectScript(err)}
              src={dataImage}
            />
            <AudaTargetModal dataImage={dataImage} intl={intl} localParams={localParams} showModal={showModal} setShowModal={setShowModal} selectedPartModal={selectedPartModal} setAudaTargetValue={setAudaTargetValue} />
          </div>
        )}
    </IntlProvider>
  );
}
